module.exports = __webpack_public_path__ + "static/recruitmentLicence-abfa06e7bb7e3c8640ebdad377c065fa.jpg";